import type { ReflectorGateOptions } from './types'

const MEGABYTE = 1024 * 1024

export const hasCoarsePointer = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(pointer: coarse)').matches

export function defaultReflectorGateOptions(): ReflectorGateOptions {
  const coarse = hasCoarsePointer()
  return {
    maxPassesPerFrame: coarse ? 4 : 8,
    targetMemoryBudgetBytes: (coarse ? 384 : 1384) * MEGABYTE,
    maxMultisample: coarse ? 2 : 4,
    evictAfterFrames: 180,
    maxAcquisitionsPerFrame: 1,
    warmupFrames: 4,
    minTextureSize: 256,
  }
}

/** Rough GPU bytes for a HalfFloat colour + depth target, with MSAA buffers. */
export function estimateTargetBytes(
  width: number,
  height: number,
  samples: number
): number {
  const pixels = width * height
  const colour = 8
  const depth = 4
  const msaa = samples > 0 ? samples * (colour + depth) : 0
  return pixels * (colour + depth + msaa)
}
